<div class="upload-container">
  <div class="title">{{ data.title }}</div>
  <div class="prompt">{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.PROMPT' | translate }}</div>
  @if (uploading) {
    <app-spinner size="medium"></app-spinner>
  } @else {
    <div class="file-container">
      <app-file-upload [type]="type" [acceptedFileTypes]="acceptedExtensions" [maxSize]="maxSize" (fileChange)="uploadInfo = $event"></app-file-upload>
    </div>
    @if (uploadInfo !== null) {
      <div class="upload-button-container">
        <button mat-raised-button color="primary" (click)="onUploadClick()">{{ 'COMMON.UPLOAD' | translate }}</button>
      </div>
    }
  }
</div>
